<!-- 由 suu 创建于 2021-07-06 星期二 -->
<template>
  <div class="top-info" @click="showLabelFloat = false">
    <div class="t-col">
      <div class="t-flex">
        <div class="c-left">
          <img class="c-img" :src="info.image" alt="" />
          <div class="c-name">{{ info.name }}</div>
        </div>
        <div class="c-center" @click="showTipsPop = true">
          <div class="r-dot" :style="{ backgroundColor: lampObj.color }"></div>
          <div class="r-title">{{ lampObj.title }}</div>
          <div class="r-que user-btn">?</div>
        </div>
      </div>
      <div class="c-right" v-if="info.collect_info">
        <img class="collect" :src="collectIcon" alt="" @click="bindCollect" />
        <div class="collect-num">{{
          info.collect_info && info.collect_info.collect_num
        }}</div>
      </div>
    </div>
    <!-- 标签 -->
    <div class="t-label">
      <div
        class="la-item user-btn"
        :class="{ 'la-item-risk': item.type == 2 }"
        v-for="(item, index) in info.tags"
        :key="index"
        @click.stop="clicklabel($event, index)"
      >
        <!-- 正常 -->
        <i class="iconfont icon-xingxing1" v-if="item.type != 2"></i>
        <!-- 风险 -->
        <i class="iconfont icon-zhuyishixiang" v-else></i>
        <div class="i-name">{{ item.title }}</div>
        <!-- 标签浮窗 -->
        <div
          class="i-desc"
          :id="'po' + index"
          :style="{
            top: showPositionTop + 'px',
            left: showPositionLeft + 'px',
            textAlign: showPositionAlign
          }"
          v-if="labelFloat[index] && showLabelFloat"
        >
          <div class="d-title">{{ item.tip.line1 }}</div>
          <div class="d-text" v-html="item.tip.line2"></div>
        </div>
      </div>
    </div>
    <TopTipsPop @close="showTipsPop = false" v-if="showTipsPop"></TopTipsPop>
  </div>
</template>

<script>
import TopTipsPop from './top-tips-pop.vue'

export default {
  name: 'top-info',

  components: { TopTipsPop },

  props: {
    info: {}
  },

  data() {
    return {
      labelFloat: [], // 标签浮窗显示对象
      labelFloatStyle: {}, // 标签浮窗style 用于定位
      showPositionTop: null,
      showPositionLeft: null,
      showPositionAlign: 'left',
      showLabelFloat: false,
      showTipsPop: false
    }
  },

  computed: {
    collectIcon() {
      return this.info && this.info.collect_info.is_collect
        ? 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/762d32b08bd955a6d856dab74f0ad57e.png'
        : 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/238311191b2ef765ebf8104f14406a78.png'
    },
    // 食物灯颜色
    lampObj() {
      switch (this.info.health_light * 1) {
        case 1:
          return { color: '#49ceba', title: '绿灯食物' }
        case 2:
          return { color: '#f7b500', title: '黄灯食物' }
        case 3:
          return { color: '#dc0050', title: '红灯食物' }
        default:
          return ''
      }
    }
  },

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    bindCollect() {
      if (!this.$http._isApp()) {
        return
      }
      let collect = this.info.collect_info.is_collect
      let num = this.info.collect_info.collect_num
      let params = {
        collect_type: 1,
        content_id: this.info.id,
        is_collect: +!collect
      }
      this.$http
        .postBaseApp('member/Collect/operateCollect', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.info.collect_info.is_collect = !collect
            let tips = ''
            if (collect) {
              this.info.collect_info.collect_num = num - 1 < 0 ? 0 : num - 1
              tips = '已取消收藏'
            } else {
              this.info.collect_info.collect_num = num + 1
              tips = '收藏成功'
            }
            this.$toast(tips)
          } else {
            this.$toast(res.msg)
          }
        })
    },
    /**
     * 点击标签
     */
    clicklabel(e, index) {
      let arr = JSON.parse(JSON.stringify(this.labelFloat))
      // 全关闭 初始化
      this.showPositionAlign = 'left'
      arr = arr.map((v) => {
        return 0
      })
      // 当前项显示
      arr[index] = 1
      this.labelFloat = arr
      this.showLabelFloat = true
      // 定位弹窗位置
      this.$nextTick(() => {
        const eleW = document.getElementById('po' + index).clientWidth
        // 定位
        // console.log('====================================')
        // console.log('eeee', e.x, eleW, document.body.clientWidth)
        // console.log('====================================')
        let top = e.y + 20 || 0
        let left = e.x || 0
        let dis = document.body.clientWidth - (eleW + e.x)
        //  右侧判断是否超出屏幕及纠正
        if (dis < -20) {
          left += dis - 20
          this.showPositionAlign = 'right'
        }
        this.showPositionTop = top // 弹出框上边距
        this.showPositionLeft = left // 弹出框左边距，根据位置适当加减
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}

.top-info {
  width: 100%;
  box-sizing: border-box;
  padding: 4vw;
  background: #fff;

  .t-col {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .t-flex {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      display: flex;
      align-items: center;
    }

    .c-left {
      max-width: 205px;
      display: flex;
      align-items: center;

      .c-img {
        width: 10vw;
        height: 10vw;
        border-radius: 1vw;
        margin-right: 4vw;
      }

      .c-name {
        font-size: 4vw;
        font-weight: 600;
        color: #000;
      }
    }

    .c-center {
      margin-left: 15px;
      display: flex;
      align-items: center;

      .r-dot {
        width: 2vw;
        height: 2vw;
        background-color: #49ceba;
        margin-right: 2vw;
        border-radius: 50%;
      }

      .r-title {
        white-space: nowrap;
        font-size: 3vw;
        font-weight: 600;
        color: #000;
        margin-right: 1.1vw;
      }

      .r-que {
        font-size: 3vw;
        font-weight: 600;
        width: 4vw;
        height: 4vw;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        border: solid 0.3vw #838aae;
        color: #838aae;
        opacity: 0.5;
        border-radius: 50%;
      }
    }

    .c-right {
      display: flex;
      align-items: center;
      flex-direction: column;
      align-items: center;
      margin-left: 15px;

      .collect {
        width: 24px;
        height: 24px;
        object-fit: contain;
      }

      .collect-num {
        margin-top: 2px;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.5);
        line-height: 14px;
      }
    }
  }

  .t-label {
    width: 100%;
    box-sizing: border-box;
    margin-top: 1vw;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .la-item {
      margin-right: 3vw;
      margin-top: 3vw;
      display: flex;
      align-items: center;
      padding: 1vw 3vw;
      background-color: #f7f7f7;
      border-radius: 99vw;
      border: solid 0vw #f1f1f1;
      position: relative;
      color: rgba(0, 0, 0, 0.5);

      & i {
        margin-right: 2vw;
      }

      .iconxingxing1 {
        background-color: #49ceba;
        color: #fff;
        font-size: 2vw;
        padding: 0.8vw;
        border-radius: 50%;
      }

      .i-name {
        font-size: 12px;
        font-weight: 600;
      }

      .i-desc {
        text-align: left;
        width: max-content;
        max-width: 50vw;
        word-break: break-all;
        background-color: #fff;
        padding: 4vw;
        box-shadow: 0vw 0vw 1.9vw 0vw rgba(0, 0, 0, 0.06);
        border-radius: 1.6vw;
        color: rgba(0, 0, 0, 0.7);

        .d-title {
          font-size: 3.2vw;
          font-weight: 600;
        }

        .d-text {
          color: rgba(0, 0, 0, 0.5);
          margin-top: 1.3vw;
          white-space: pre-line;
        }

        position: fixed;
        z-index: 19;
      }
    }

    .la-item-risk {
      background-color: #ff8282;
      color: #fff;

      .iconzhuyishixiang {
        font-size: 4.1vw;
        color: #fff;
        transform: rotate(180deg);
      }
    }
  }
}
</style>
